/**
 * Created by ah on 14/03/17.
 */
export const Looklet = {
    ViewType:{
        VIEW:'VIEW',
    },
    DisplayType:{
        FABRIC_DETAIL:'FABRIC_DETAIL',
        GHOST:'GHOST',
    },
    ViewState:{
        APPROVED:"APPROVED",
        COMPLETED:"COMPLETED",
        RECALLED:"RECALLED",
        AWAITING_RETOUCH:"AWAITING_RETOUCH",
        RETOUCH_CHECK_OUT:"RETOUCH_CHECK_OUT",
        REJECTED_RETOUCH:"REJECTED_RETOUCH",
        PRE_PROCESSING_CHECK_OUT:"PRE_PROCESSING_CHECK_OUT",

    }
}


// WEBPACK FOOTER //
// ./src/model/constants/looklet.js